import { render, staticRenderFns } from "./CustomerTableServices.vue?vue&type=template&id=2214d914&scoped=true"
import script from "./CustomerTableServices.vue?vue&type=script&lang=js"
export * from "./CustomerTableServices.vue?vue&type=script&lang=js"
import style0 from "./CustomerTableServices.vue?vue&type=style&index=0&id=2214d914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2214d914",
  null
  
)

export default component.exports